(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tag-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyText = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const textArea = document.createElement('textarea');
      textArea.value = value;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    };

    const initializeTagHelpers = (root = document) => {
      root.querySelectorAll('[data-collection-tag-helper]:not([data-initialized])').forEach((helper) => {
        helper.dataset.initialized = 'true';

        const search = helper.querySelector('[data-collection-tag-search]');
        const list = helper.querySelector('[data-collection-tag-list]');
        const empty = helper.querySelector('[data-collection-tag-empty]');
        const status = helper.querySelector('[data-collection-tag-status]');
        let tags = [];

        try {
          tags = JSON.parse(helper.dataset.tags || '[]');
        } catch (error) {
          empty.textContent = 'Collection tags could not be loaded.';
          empty.hidden = false;
          return;
        }

        const renderTags = () => {
          const query = search.value.trim().toLocaleLowerCase();
          const matches = tags.filter((tag) => tag.toLocaleLowerCase().includes(query));
          const fragment = document.createDocumentFragment();

          matches.forEach((tag) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'collection-tag-filter__editor-tag';
            button.dataset.collectionTag = tag;
            button.textContent = tag;
            fragment.appendChild(button);
          });

          list.replaceChildren(fragment);
          empty.hidden = matches.length > 0;
          status.textContent = '';
        };

        search.addEventListener('input', renderTags);
        list.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-collection-tag]');

          if (!button) return;

          try {
            await copyText(button.dataset.collectionTag);
            status.textContent = `Copied “${button.dataset.collectionTag}”.`;
          } catch (error) {
            status.textContent = 'Copy failed. Select the tag text and copy it manually.';
          }
        });

        renderTags();
      });
    };

    initializeTagHelpers();
    document.addEventListener('shopify:section:load', (event) => initializeTagHelpers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-restock"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-items"] && !Shopify.designMode) return;
  try {
    
  class RelatedProductsCarousel {
    constructor(container) {
      this.container = container;
      this.carousel = container.querySelector('[data-carousel="carousel"]');
      if (!this.carousel) return;

      this.prevBtn = container.querySelector('.carousel-nav--prev');
      this.nextBtn = container.querySelector('.carousel-nav--next');
      this.updateButtons = this.updateButtons.bind(this);

      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.carousel.addEventListener('scroll', this.updateButtons, { passive: true });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.carousel);
      this.updateButtons();
    }

    scroll(direction) {
      const scrollAmount = this.carousel.offsetWidth;
      const scrollLeft = direction === 'prev' ? -scrollAmount : scrollAmount;
      this.carousel.scrollBy({ left: scrollLeft, behavior: 'smooth' });
    }

    updateButtons() {
      const atStart = this.carousel.scrollLeft <= 1;
      const atEnd =
        this.carousel.scrollLeft + this.carousel.clientWidth >=
        this.carousel.scrollWidth - 1;

      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }

  const initializeRelatedProductCarousels = (root = document) => {
    root.querySelectorAll('.related-items .resource-list-wrapper--carousel').forEach((wrapper) => {
      if (wrapper.dataset.carouselInitialized === 'true') return;

      wrapper.dataset.carouselInitialized = 'true';
      new RelatedProductsCarousel(wrapper);
    });
  };

  initializeRelatedProductCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initializeRelatedProductCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsr-search-advanced"]) return;
  try {
    
  class TsrSearchAdvanced extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.productResults = [];
      this.matchedProductResults = [];
      this.renderedProductCount = 0;
      this.productBatchObserver = null;
      this.productBatchLoading = false;
      this.productRenderGeneration = 0;
      this.productMarkupPromises = new Map();
      this.refreshElementReferences();
      this.bindTabInteractions();
      document.addEventListener('shopify:search:update', this.handleShopifySearchUpdate);
      this.addEventListener('click', this.handleComponentClick);
      this.showBackLink();
      this.selectInitialTab();
      this.syncProductControls();
      this.initializeProductResults(this);
      this.applyProductMatchMode();
      this.sortNewsNewestFirst();
      this.updateCounts();
      if (this.dataset.query) this.hydrateResults();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:search:update', this.handleShopifySearchUpdate);
      this.removeEventListener('click', this.handleComponentClick);
      this.disconnectProductBatchObserver();
    }

    refreshElementReferences() {
      this.tabs = Array.from(this.querySelectorAll('[data-tsr-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-tsr-panel]'));
      this.status = this.querySelector('[data-tsr-search-status]');
      this.totalOutput = this.querySelector('[data-tsr-total-count]');
    }

    bindTabInteractions() {
      this.tabs.forEach((tab) => {
        if (tab.dataset.tsrTabBound === 'true') return;
        tab.dataset.tsrTabBound = 'true';
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
      });
    }

    handleShopifySearchUpdate = (event) => {
      const sourceSection = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
      if (sourceSection && !sourceSection.contains(this)) return;
      const updatePromise = event.promise;
      if (!(updatePromise instanceof Promise)) return;
      const sectionId = this.dataset.sectionId;
      updatePromise.then(() => {
        const current = document.querySelector(
          `[data-tsr-search-advanced][data-section-id="${CSS.escape(sectionId)}"]`
        );
        if (current instanceof TsrSearchAdvanced) current.refreshAfterNativeControls();
      });
    };

    async refreshAfterNativeControls() {
      this.refreshElementReferences();
      this.bindTabInteractions();
      this.selectInitialTab();
      this.syncProductControls();
      this.initializeProductResults(this);
      this.applyProductMatchMode();
      this.updateCounts();
      this.setAttribute('aria-busy', 'true');
      await this.hydrateResults();
    }

    handleComponentClick = (event) => {
      const tab = event.target.closest('[data-tsr-tab]');
      if (tab && this.contains(tab) && this.panelFor(tab.dataset.tsrTab)) {
        event.preventDefault();
        this.selectTab(tab.dataset.tsrTab, true);
        return;
      }
      this.cleanPaginationUrl(event);
      const button = event.target.closest('[data-tsr-product-load-more-button]');
      if (!button) return;
      event.preventDefault();
      this.renderProductBatch(false, true);
    };

    handleTabKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const visibleTabs = this.tabs.filter((tab) => !tab.hidden);
      const currentIndex = visibleTabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;
      event.preventDefault();
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (currentIndex + offset + visibleTabs.length) % visibleTabs.length;
      visibleTabs[nextIndex].focus();
      visibleTabs[nextIndex].click();
    }

    selectInitialTab() {
      const requested = window.location.hash.replace('#', '');
      const requestedPanel = this.panelFor(requested);
      const initial = requestedPanel ? requested : this.dataset.initialTab;
      this.selectTab(initial, false);
    }

    selectTab(name, updateHash) {
      if (!this.panelFor(name)) return;
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tsrTab === name;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.tsrPanel !== name;
      });
      if (updateHash) {
        const url = new URL(window.location.href);
        url.hash = name;
        window.history.replaceState({}, '', url);
      }
    }

    panelFor(name) {
      return this.panels.find((panel) => panel.dataset.tsrPanel === name);
    }

    initializeProductResults(source) {
      const results = [];
      this.collectProductResults(source, results, new Set());
      this.setProductResults(results);
    }

    collectProductResults(source, results, seenProductIds) {
      const sourceGrid = source
        .querySelector('[data-tsr-panel="products"]')
        ?.querySelector('.tsr-search-advanced__grid');
      sourceGrid?.querySelectorAll('[data-tsr-product-result]').forEach((item) => {
        const productId = item.dataset.tsrProductId || item.querySelector('a')?.href || '';
        if (productId && seenProductIds.has(productId)) {
          item.remove();
          return;
        }
        if (productId) seenProductIds.add(productId);

        item.querySelectorAll('img').forEach((image) => {
          image.loading = 'lazy';
          image.fetchPriority = 'low';
        });

        let tags = [];
        try {
          tags = JSON.parse(item.dataset.tsrProductTags || '[]');
        } catch (error) {
          tags = [];
        }

        results.push({
          id: productId,
          handle: item.dataset.tsrProductHandle || '',
          price: Number.parseInt(item.dataset.tsrProductPrice || '0', 10),
          title: item.dataset.tsrProductTitle || '',
          productType: item.dataset.tsrProductType || '',
          tags,
          publishedAt: Number.parseInt(item.dataset.tsrProductPublishedAt || '0', 10),
          relevanceRank: null,
          markup: item.outerHTML,
        });
        item.remove();
      });
    }

    setProductResults(results) {
      this.disconnectProductBatchObserver();
      this.productResults = results;
      this.matchedProductResults = [];
      this.renderedProductCount = 0;
      this.productBatchLoading = false;
      this.productRenderGeneration += 1;
    }

    async renderProductBatch(reset = false, focusFirstNewItem = false) {
      const grid = this.panelFor('products')?.querySelector('.tsr-search-advanced__grid');
      const loadMore = this.panelFor('products')?.querySelector('[data-tsr-product-load-more]');
      if (!grid || !loadMore) return null;
      if (this.productBatchLoading && !reset) return null;

      if (reset) {
        grid.replaceChildren();
        this.renderedProductCount = 0;
      }

      this.disconnectProductBatchObserver();
      this.productBatchLoading = true;
      const renderGeneration = this.productRenderGeneration;
      const batchSize = Math.max(1, Number.parseInt(this.dataset.productBatchSize || '24', 10));
      const start = this.renderedProductCount;
      const end = Math.min(start + batchSize, this.matchedProductResults.length);
      const batch = this.matchedProductResults.slice(start, end);
      await this.hydrateProductMarkupBatch(batch);
      if (renderGeneration !== this.productRenderGeneration) return null;

      const fragment = document.createDocumentFragment();
      let firstNewItem = null;

      batch.forEach((result, batchIndex) => {
        if (!result.markup) return;
        const template = document.createElement('template');
        template.innerHTML = result.markup.trim();
        const item = template.content.firstElementChild;
        if (!(item instanceof HTMLElement)) return;
        item.hidden = false;
        item.removeAttribute('aria-hidden');
        item.querySelectorAll('img').forEach((image, imageIndex) => {
          const prioritize = start + batchIndex < 2 && imageIndex === 0;
          image.loading = prioritize ? 'eager' : 'lazy';
          image.fetchPriority = prioritize ? 'high' : 'low';
        });
        if (!firstNewItem) firstNewItem = item;
        fragment.append(item);
      });

      grid.append(fragment);
      this.renderedProductCount = end;
      this.productBatchLoading = false;
      loadMore.hidden = end >= this.matchedProductResults.length;
      this.setupProductBatchObserver();

      if (focusFirstNewItem && firstNewItem) {
        requestAnimationFrame(() => {
          firstNewItem.querySelector('a, button')?.focus({ preventScroll: true });
        });
      }
      return firstNewItem;
    }

    async hydrateProductMarkupBatch(results) {
      for (let batchStart = 0; batchStart < results.length; batchStart += 6) {
        const batch = results.slice(batchStart, batchStart + 6);
        await Promise.all(
          batch.map(async (result) => {
            if (result.markup) return;
            try {
              result.markup = await this.fetchProductCardMarkup(result);
            } catch (error) {
              if (this.status) this.status.textContent = this.dataset.partialMessage;
            }
          })
        );
      }
    }

    fetchProductCardMarkup(result) {
      if (!result.handle) return Promise.resolve('');
      if (this.productMarkupPromises.has(result.handle)) return this.productMarkupPromises.get(result.handle);

      const request = (async () => {
        const url = new URL(
          `${this.dataset.productCardBaseUrl}${encodeURIComponent(result.handle)}`,
          window.location.origin
        );
        url.searchParams.set('view', this.dataset.productCardView);
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Product card request failed: ${response.status}`);
        const markup = await response.text();
        const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        const item = documentFragment.querySelector('[data-tsr-product-result]');
        if (!item) throw new Error('Product card response was invalid');
        return item.outerHTML;
      })();

      this.productMarkupPromises.set(result.handle, request);
      return request;
    }

    setupProductBatchObserver() {
      this.disconnectProductBatchObserver();
      const loadMore = this.panelFor('products')?.querySelector('[data-tsr-product-load-more]');
      if (!loadMore || loadMore.hidden || !('IntersectionObserver' in window)) return;
      this.productBatchObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.renderProductBatch();
        },
        { rootMargin: '600px 0px' }
      );
      this.productBatchObserver.observe(loadMore);
    }

    disconnectProductBatchObserver() {
      this.productBatchObserver?.disconnect();
      this.productBatchObserver = null;
    }

    async hydrateResults() {
      const requests = [this.loadType('product'), this.loadType('article')];
      const results = await Promise.allSettled(requests);
      let failed = results.some((result) => result.status === 'rejected');
      if (this.dataset.productMatchMode === 'strict' && this.dataset.enableTypoTolerance === 'true') {
        try {
          await this.recoverTypoProductResults();
        } catch (error) {
          failed = true;
        }
      }
      this.setAttribute('aria-busy', 'false');
      if (this.status) this.status.textContent = failed ? this.dataset.partialMessage : '';
      this.updateCounts();
      this.ensureActiveTab();
    }

    async loadType(type, query = this.dataset.query) {
      const url = new URL(this.dataset.searchUrl, window.location.origin);
      const currentUrl = new URL(window.location.href);
      let selectedProductSort = '';
      url.searchParams.set('q', query);
      url.searchParams.set('type', type);
      if (type === 'product') {
        currentUrl.searchParams.forEach((value, name) => {
          if (name.startsWith('filter.') && name !== 'filter.v.availability') {
            url.searchParams.append(name, value);
          }
        });
        selectedProductSort =
          currentUrl.searchParams.get('sort_by') || this.dataset.defaultProductSort || 'price-descending';
        url.searchParams.set(
          'sort_by',
          this.dataset.productMatchMode === 'strict' ? 'title-ascending' : selectedProductSort
        );
      } else {
        url.searchParams.set('sort_by', 'relevance');
      }
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('sections', this.dataset.sectionId);
      url.searchParams.set('page', '1');
      const source = await this.fetchSearchSource(url);
      if (type === 'product') {
        const productResults = [];
        const seenProductIds = new Set();
        this.collectProductResults(source, productResults, seenProductIds);
        let productPageError = null;
        if (this.dataset.productMatchMode === 'strict') {
          try {
            await this.loadRemainingProductPages(url, source, productResults, seenProductIds);
            await this.loadFullProductCatalog(productResults, seenProductIds);
            if (selectedProductSort === 'relevance') await this.loadProductRelevanceRanks(url, productResults);
          } catch (error) {
            productPageError = error;
          }
        }
        this.replacePanel(source, 'products');
        this.setProductResults(productResults);
        this.applyProductMatchMode();
        if (productPageError) throw productPageError;
      } else {
        this.replacePanel(source, 'recipes');
        this.replacePanel(source, 'news');
        let articlePageError = null;
        try {
          await this.loadRemainingArticlePages(url, source);
        } catch (error) {
          articlePageError = error;
        }
        this.updateArticleResultCounts();
        this.sortNewsNewestFirst();
        if (articlePageError) throw articlePageError;
      }
    }

    async fetchSearchSource(url) {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
      const payload = await response.json();
      const markup = payload[this.dataset.sectionId];
      if (!markup) throw new Error('Search section response was empty');
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const source = documentFragment.querySelector('[data-tsr-search-advanced]');
      if (!source) throw new Error('Search section response was invalid');
      return source;
    }

    async loadFullProductCatalog(productResults, seenProductIds) {
      const url = new URL(this.dataset.productIndexUrl, window.location.origin);
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.forEach((value, name) => {
        if (name.startsWith('filter.') && name !== 'filter.v.availability') {
          url.searchParams.append(name, value);
        }
      });
      url.searchParams.set('page', '1');

      const firstPageSource = await this.fetchProductIndexSource(url);
      this.collectIndexedProducts(firstPageSource, productResults, seenProductIds);
      const totalPages = Number.parseInt(firstPageSource.dataset.pageCount || '1', 10);
      if (!Number.isFinite(totalPages) || totalPages <= 1) return;

      const pageNumbers = Array.from({ length: totalPages - 1 }, (_, index) => index + 2);
      let failed = false;
      for (let batchStart = 0; batchStart < pageNumbers.length; batchStart += 3) {
        const batch = pageNumbers.slice(batchStart, batchStart + 3);
        const responses = await Promise.allSettled(
          batch.map((pageNumber) => {
            const pageUrl = new URL(url);
            pageUrl.searchParams.set('page', String(pageNumber));
            return this.fetchProductIndexSource(pageUrl);
          })
        );
        responses.forEach((response) => {
          if (response.status === 'rejected') {
            failed = true;
            return;
          }
          this.collectIndexedProducts(response.value, productResults, seenProductIds);
        });
      }
      if (failed) throw new Error('One or more product catalog pages could not load');
    }

    async fetchProductIndexSource(url) {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Product catalog request failed: ${response.status}`);
      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const source = documentFragment.querySelector('[data-tsr-search-product-index]');
      if (!source) throw new Error('Product catalog response was invalid');
      return source;
    }

    collectIndexedProducts(source, productResults, seenProductIds) {
      source.querySelectorAll('[data-tsr-search-index-product]').forEach((item) => {
        const productId = item.dataset.tsrProductId || '';
        if (!productId || seenProductIds.has(productId)) return;
        seenProductIds.add(productId);

        let tags = [];
        try {
          tags = JSON.parse(item.dataset.tsrProductTags || '[]');
        } catch (error) {
          tags = [];
        }

        productResults.push({
          id: productId,
          handle: item.dataset.tsrProductHandle || '',
          price: Number.parseInt(item.dataset.tsrProductPrice || '0', 10),
          title: item.dataset.tsrProductTitle || '',
          productType: item.dataset.tsrProductType || '',
          tags,
          publishedAt: Number.parseInt(item.dataset.tsrProductPublishedAt || '0', 10),
          relevanceRank: null,
          markup: '',
        });
      });
    }

    async loadRemainingProductPages(baseUrl, firstPageSource, productResults, seenProductIds) {
      const totalPages = Number.parseInt(firstPageSource.dataset.searchPages || '1', 10);
      if (!Number.isFinite(totalPages) || totalPages <= 1) return;
      const pageNumbers = Array.from({ length: totalPages - 1 }, (_, index) => index + 2);
      let failed = false;

      for (let batchStart = 0; batchStart < pageNumbers.length; batchStart += 3) {
        const batch = pageNumbers.slice(batchStart, batchStart + 3);
        const results = await Promise.allSettled(
          batch.map((pageNumber) => {
            const pageUrl = new URL(baseUrl);
            pageUrl.searchParams.set('page', String(pageNumber));
            return this.fetchSearchSource(pageUrl);
          })
        );

        results.forEach((result) => {
          if (result.status === 'rejected') {
            failed = true;
            return;
          }

          this.collectProductResults(result.value, productResults, seenProductIds);
        });
      }

      if (failed) throw new Error('One or more product search pages could not load');
    }

    async loadProductRelevanceRanks(baseUrl, productResults) {
      const relevanceUrl = new URL(baseUrl);
      relevanceUrl.searchParams.set('sort_by', 'relevance');
      relevanceUrl.searchParams.set('page', '1');
      const firstPageSource = await this.fetchSearchSource(relevanceUrl);
      const totalPages = Number.parseInt(firstPageSource.dataset.searchPages || '1', 10);
      const sources = [firstPageSource];
      let failed = false;

      for (let batchStart = 2; batchStart <= totalPages; batchStart += 3) {
        const pageNumbers = Array.from(
          { length: Math.min(3, totalPages - batchStart + 1) },
          (_, index) => batchStart + index
        );
        const results = await Promise.allSettled(
          pageNumbers.map((pageNumber) => {
            const pageUrl = new URL(relevanceUrl);
            pageUrl.searchParams.set('page', String(pageNumber));
            return this.fetchSearchSource(pageUrl);
          })
        );
        results.forEach((result) => {
          if (result.status === 'fulfilled') sources.push(result.value);
          else failed = true;
        });
      }

      const relevanceRanks = new Map();
      sources.forEach((source) => {
        source
          .querySelector('[data-tsr-panel="products"]')
          ?.querySelectorAll('[data-tsr-product-result]')
          .forEach((item) => {
            const productId = item.dataset.tsrProductId;
            if (productId && !relevanceRanks.has(productId)) relevanceRanks.set(productId, relevanceRanks.size);
          });
      });
      productResults.forEach((result) => {
        const rank = relevanceRanks.get(result.id);
        result.relevanceRank = rank === undefined ? null : rank;
      });

      if (failed) throw new Error('One or more relevance search pages could not load');
    }

    async loadRemainingArticlePages(baseUrl, firstPageSource) {
      const totalPages = Number.parseInt(firstPageSource.dataset.searchPages || '1', 10);
      if (!Number.isFinite(totalPages) || totalPages <= 1) return;

      const resultKinds = ['recipes', 'news'];
      const targetGrids = new Map();
      const seenArticleIds = new Map();
      resultKinds.forEach((kind) => {
        const grid = this.panelFor(kind)?.querySelector('.tsr-search-advanced__grid');
        targetGrids.set(kind, grid);
        seenArticleIds.set(
          kind,
          new Set(
            Array.from(grid?.querySelectorAll(`[data-tsr-result-kind="${kind}"]`) || [])
              .map((item) => item.dataset.tsrArticleId || item.querySelector('a')?.href)
              .filter(Boolean)
          )
        );
      });

      const pageNumbers = Array.from({ length: totalPages - 1 }, (_, index) => index + 2);
      let failed = false;

      for (let batchStart = 0; batchStart < pageNumbers.length; batchStart += 3) {
        const batch = pageNumbers.slice(batchStart, batchStart + 3);
        const results = await Promise.allSettled(
          batch.map((pageNumber) => {
            const pageUrl = new URL(baseUrl);
            pageUrl.searchParams.set('page', String(pageNumber));
            return this.fetchSearchSource(pageUrl);
          })
        );

        results.forEach((result) => {
          if (result.status === 'rejected') {
            failed = true;
            return;
          }

          resultKinds.forEach((kind) => {
            const targetGrid = targetGrids.get(kind);
            const seenIds = seenArticleIds.get(kind);
            const sourcePanel = result.value.querySelector(`[data-tsr-panel="${kind}"]`);
            sourcePanel?.querySelectorAll(`[data-tsr-result-kind="${kind}"]`).forEach((item) => {
              const articleId = item.dataset.tsrArticleId || item.querySelector('a')?.href;
              if (articleId && seenIds.has(articleId)) return;
              if (articleId) seenIds.add(articleId);
              targetGrid?.append(item);
            });
          });
        });
      }

      if (!failed) {
        resultKinds.forEach((kind) => {
          const pagination = this.panelFor(kind)?.querySelector('.tsr-search-advanced__pagination');
          if (pagination) pagination.hidden = true;
        });
      }
      if (failed) throw new Error('One or more article search pages could not load');
    }

    updateArticleResultCounts() {
      const counts = {
        recipes: this.panelFor('recipes')?.querySelectorAll('[data-tsr-result-kind="recipes"]').length || 0,
        news: this.panelFor('news')?.querySelectorAll('[data-tsr-result-kind="news"]').length || 0,
      };
      this.dataset.recipesCount = String(counts.recipes);
      this.dataset.newsCount = String(counts.news);
      Object.entries(counts).forEach(([kind, count]) => {
        const emptyMessage = this.panelFor(kind)?.querySelector('.tsr-search-advanced__empty');
        if (emptyMessage) emptyMessage.hidden = count > 0;
      });
    }

    replacePanel(source, name) {
      const targetPanel = this.panelFor(name);
      const sourcePanel = source.querySelector(`[data-tsr-panel="${name}"]`);
      const targetContent = targetPanel?.querySelector(`[data-tsr-panel-content="${name}"]`);
      const sourceContent = sourcePanel?.querySelector(`[data-tsr-panel-content="${name}"]`);
      if (!targetPanel || !targetContent || !sourceContent) return;
      targetContent.innerHTML = sourceContent.innerHTML;
      targetPanel.dataset.hydrated = 'true';
      if (name === 'products') this.syncProductControls();
      if (name === 'news') this.sortNewsNewestFirst();
    }

    sortNewsNewestFirst() {
      const grid = this.panelFor('news')?.querySelector('.tsr-search-advanced__grid');
      if (!grid) return;
      const items = Array.from(grid.querySelectorAll('[data-tsr-result-kind="news"]'));
      items
        .sort((left, right) => {
          const leftDate = Number.parseInt(left.dataset.tsrArticlePublishedAt || '0', 10);
          const rightDate = Number.parseInt(right.dataset.tsrArticlePublishedAt || '0', 10);
          return rightDate - leftDate;
        })
        .forEach((item) => grid.append(item));
    }

    applyProductMatchMode() {
      const panel = this.panelFor('products');
      if (!panel) return 0;
      const items = this.productResults || [];
      const emptyMessage = panel.querySelector('[data-tsr-products-empty]');
      const pagination = panel.querySelector('.tsr-search-advanced__pagination');
      const strict = this.dataset.productMatchMode === 'strict';
      const matchingItems = strict ? items.filter((item) => this.productMatchesQuery(item)) : [...items];
      const visibleCount = matchingItems.length;
      if (strict && pagination) pagination.hidden = true;

      this.matchedProductResults = this.applyProductSort(matchingItems);
      void this.renderProductBatch(true);
      if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
      this.dataset.productsCount = String(visibleCount);
      this.updateProductControlCounts(visibleCount);
      return visibleCount;
    }

    updateProductControlCounts(count) {
      const label = count === 1 ? this.dataset.productSingular : this.dataset.productPlural;
      this.panelFor('products')?.querySelectorAll('[data-testid="products-count"] [role="status"]').forEach((output) => {
        output.textContent = `${count.toLocaleString()} ${label}`;
      });
    }

    syncProductControls() {
      const controls = this.querySelector('[data-tsr-product-controls]');
      const currentSort =
        new URL(window.location.href).searchParams.get('sort_by') ||
        this.dataset.defaultProductSort ||
        'price-descending';
      this.enhanceNativeSortControls(controls, currentSort);

      controls?.querySelectorAll('form').forEach((form) => {
        this.upsertHiddenInput(form, 'type', 'product');
        this.upsertHiddenInput(form, 'options[prefix]', 'last');
      });
    }

    enhanceNativeSortControls(controls, currentSort) {
      if (!controls) return;
      const addedOptions = [
        { value: 'title-ascending', label: this.dataset.sortTitleAscendingLabel },
        { value: 'title-descending', label: this.dataset.sortTitleDescendingLabel },
        { value: 'created-ascending', label: this.dataset.sortCreatedAscendingLabel },
        { value: 'created-descending', label: this.dataset.sortCreatedDescendingLabel },
      ];

      controls.querySelectorAll('sorting-filter-component').forEach((component, componentIndex) => {
        component.querySelectorAll('select[name="sort_by"]').forEach((select) => {
          const relevanceOption = select.querySelector('option[value="relevance"]');
          if (relevanceOption) relevanceOption.textContent = this.dataset.sortRelevanceLabel;
          addedOptions.forEach(({ value, label }) => {
            if (select.querySelector(`option[value="${value}"]`)) return;
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            select.append(option);
          });
          if (Array.from(select.options).some((option) => option.value === currentSort)) select.value = currentSort;
        });

        const optionsList = component.querySelector('.sorting-filter__options-inner');
        const template = optionsList?.querySelector(':scope > label');
        const relevanceInput = component.querySelector('input[name="sort_by"][value="relevance"]');
        if (relevanceInput) {
          relevanceInput.dataset.optionName = this.dataset.sortRelevanceLabel;
          const relevanceLabel = relevanceInput.closest('label')?.querySelector('.sorting-filter__label');
          if (relevanceLabel) relevanceLabel.textContent = this.dataset.sortRelevanceLabel;
        }

        if (optionsList && template) {
          addedOptions.forEach(({ value, label }) => {
            if (optionsList.querySelector(`input[name="sort_by"][value="${value}"]`)) return;
            const clone = template.cloneNode(true);
            const input = clone.querySelector('input[name="sort_by"]');
            const optionRow = clone.querySelector('[role="option"]');
            const optionLabel = clone.querySelector('.sorting-filter__label');
            if (!input || !optionRow || !optionLabel) return;
            const id = `sort-option-${value}-${this.dataset.sectionId}-${componentIndex}`;
            clone.setAttribute('for', id);
            input.id = id;
            input.value = value;
            input.dataset.optionName = label;
            optionLabel.textContent = label;
            optionsList.append(clone);
          });
        }

        const inputs = component.querySelectorAll('input[name="sort_by"]');
        inputs.forEach((input) => {
          const selected = input.value === currentSort;
          input.checked = selected;
          const optionRow = input.closest('[role="option"]');
          optionRow?.setAttribute('aria-selected', selected ? 'true' : 'false');
          if (optionRow) optionRow.tabIndex = selected ? 0 : -1;
        });
        const selectedInput = component.querySelector(`input[name="sort_by"][value="${currentSort}"]`);
        const status = component.querySelector('.facets__status');
        if (status && selectedInput) status.textContent = selectedInput.dataset.optionName || '';
      });
    }

    upsertHiddenInput(form, name, value) {
      let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.append(input);
      }
      input.value = value;
    }

    applyProductSort(items) {
      const sort =
        new URL(window.location.href).searchParams.get('sort_by') ||
        this.dataset.defaultProductSort ||
        'price-descending';
      const supported = [
        'relevance',
        'price-ascending',
        'price-descending',
        'title-ascending',
        'title-descending',
        'created-ascending',
        'created-descending',
      ];
      if (!supported.includes(sort)) return [...items];
      const ordered = [...items].sort((left, right) => {
        if (sort === 'relevance') {
          const leftRank = left.relevanceRank;
          const rightRank = right.relevanceRank;
          const normalizedLeftRank = Number.isFinite(leftRank) ? leftRank : Number.MAX_SAFE_INTEGER;
          const normalizedRightRank = Number.isFinite(rightRank) ? rightRank : Number.MAX_SAFE_INTEGER;
          if (normalizedLeftRank !== normalizedRightRank) return normalizedLeftRank - normalizedRightRank;
          return left.title.localeCompare(right.title);
        }
        if (sort === 'price-ascending' || sort === 'price-descending') {
          const direction = sort === 'price-descending' ? -1 : 1;
          if (left.price !== right.price) return (left.price - right.price) * direction;
          return left.title.localeCompare(right.title);
        }
        if (sort === 'title-ascending' || sort === 'title-descending') {
          const direction = sort === 'title-descending' ? -1 : 1;
          return left.title.localeCompare(right.title) * direction;
        }
        if (left.publishedAt === 0 && right.publishedAt !== 0) return 1;
        if (right.publishedAt === 0 && left.publishedAt !== 0) return -1;
        const direction = sort === 'created-descending' ? -1 : 1;
        if (left.publishedAt !== right.publishedAt) return (left.publishedAt - right.publishedAt) * direction;
        return left.title.localeCompare(right.title);
      });
      return ordered;
    }

    productMatchesQuery(item) {
      const query = this.normalizeSearchText(this.dataset.query);
      if (!query) return true;
      const title = this.normalizeSearchText(item.title);
      const productType = this.normalizeSearchText(item.productType);
      const tags = item.tags.map((tag) => this.normalizeSearchText(tag));

      if (title.includes(query) || productType.includes(query) || tags.includes(query)) return true;
      if (this.dataset.enableTypoTolerance !== 'true') return false;

      const queryTokens = this.searchTokens(query);
      const fieldTokens = this.searchTokens(`${title} ${productType}`);
      const fieldsMatch = queryTokens.every((queryToken) =>
        fieldTokens.some((fieldToken) => this.fuzzyTokenMatch(queryToken, fieldToken))
      );
      const tagMatches = tags.some((tag) => this.fuzzyPhraseMatch(queryTokens, this.searchTokens(tag)));
      return fieldsMatch || tagMatches;
    }

    normalizeSearchText(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    searchTokens(value) {
      const stopwords = new Set(['a', 'an', 'and', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);
      const tokens = this.normalizeSearchText(value).split(' ').filter(Boolean);
      const meaningful = tokens.filter((token) => !stopwords.has(token));
      return meaningful.length > 0 ? meaningful : tokens;
    }

    fuzzyPhraseMatch(queryTokens, fieldTokens) {
      if (queryTokens.length !== fieldTokens.length) return false;
      return queryTokens.every((queryToken, index) => this.fuzzyTokenMatch(queryToken, fieldTokens[index]));
    }

    fuzzyTokenMatch(queryToken, fieldToken) {
      if (queryToken === fieldToken) return true;
      if (queryToken.length < 4 || fieldToken.length < 4) return false;
      if (queryToken[0] !== fieldToken[0]) return false;
      const threshold = queryToken.length >= 6 ? 2 : 1;
      if (Math.abs(queryToken.length - fieldToken.length) > threshold) return false;
      return this.levenshteinDistance(queryToken, fieldToken) <= threshold;
    }

    levenshteinDistance(left, right) {
      const previous = Array.from({ length: right.length + 1 }, (_, index) => index);
      for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
        const current = [leftIndex];
        for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
          const substitution = previous[rightIndex - 1] + (left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1);
          current[rightIndex] = Math.min(previous[rightIndex] + 1, current[rightIndex - 1] + 1, substitution);
        }
        previous.splice(0, previous.length, ...current);
      }
      return previous[right.length];
    }

    async recoverTypoProductResults() {
      if (Number.parseInt(this.dataset.productsCount || '0', 10) > 0) return false;
      const correctedQuery = this.correctedProductQuery();
      if (!correctedQuery) return false;
      if (correctedQuery === this.normalizeSearchText(this.dataset.query)) return false;
      await this.loadType('product', correctedQuery);
      this.dataset.correctedProductQuery = correctedQuery;
      return Number.parseInt(this.dataset.productsCount || '0', 10) > 0;
    }

    correctedProductQuery() {
      const queryTokens = this.searchTokens(this.dataset.query);
      if (queryTokens.length === 0) return '';
      const frequencies = this.correctionTokenFrequencies();
      const correctedTokens = queryTokens.map((queryToken) => this.closestCorrection(queryToken, frequencies));
      return correctedTokens.join(' ');
    }

    correctionTokenFrequencies() {
      const frequencies = new Map();
      const addValue = (value, weight = 1) => {
        this.searchTokens(value).forEach((token) => {
          frequencies.set(token, (frequencies.get(token) || 0) + weight);
        });
      };

      String(this.dataset.typoVocabulary || '')
        .split(',')
        .forEach((value) => addValue(value, 4));
      this.querySelectorAll('.tsr-search-article-card__title').forEach((title) => addValue(title.textContent, 2));
      this.productResults.forEach((item) => {
        addValue(item.title, 2);
        addValue(item.productType, 2);
        item.tags.forEach((tag) => addValue(tag, 1));
      });
      return frequencies;
    }

    closestCorrection(queryToken, frequencies) {
      if (frequencies.has(queryToken)) return queryToken;
      const threshold = queryToken.length >= 6 ? 2 : queryToken.length >= 4 ? 1 : 0;
      if (threshold === 0) return queryToken;
      let bestToken = queryToken;
      let bestDistance = threshold + 1;
      let bestFrequency = -1;

      frequencies.forEach((frequency, candidate) => {
        if (candidate.length < 4 || candidate[0] !== queryToken[0]) return;
        if (Math.abs(candidate.length - queryToken.length) > threshold) return;
        const distance = this.levenshteinDistance(queryToken, candidate);
        if (distance > threshold) return;
        if (distance < bestDistance || (distance === bestDistance && frequency > bestFrequency)) {
          bestToken = candidate;
          bestDistance = distance;
          bestFrequency = frequency;
        }
      });
      return bestToken;
    }

    updateCounts() {
      const counts = {
        products: Number.parseInt(this.dataset.productsCount || '0', 10),
        recipes: Number.parseInt(this.dataset.recipesCount || '0', 10),
        news: Number.parseInt(this.dataset.newsCount || '0', 10),
      };
      Object.entries(counts).forEach(([name, count]) => {
        const label = this.querySelector(`[data-tsr-tab-count="${name}"]`);
        const tab = this.tabs.find((item) => item.dataset.tsrTab === name);
        const panel = this.panelFor(name);
        if (label) label.textContent = ` (${count})`;
        if (tab && panel?.dataset.hydrated === 'true') tab.hidden = count === 0;
      });
      const total = counts.products + counts.recipes + counts.news;
      if (this.totalOutput) {
        const suffix = total === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
        this.totalOutput.textContent = `${total} ${suffix}`;
      }
    }

    ensureActiveTab() {
      const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (active && !active.hidden) return;
      const available = this.tabs.find((tab) => !tab.hidden);
      if (available) this.selectTab(available.dataset.tsrTab, false);
    }

    cleanPaginationUrl(event) {
      const link = event.target.closest('.tsr-search-advanced__pagination a');
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.delete('sections');
      url.searchParams.delete('section_id');
      link.href = url.toString();
    }

    showBackLink() {
      if (!document.referrer) return;
      const referrer = new URL(document.referrer);
      if (referrer.hostname !== window.location.hostname || !referrer.pathname.includes('/blogs/')) return;
      const container = this.querySelector('[data-tsr-search-back]');
      const link = this.querySelector('[data-tsr-search-back-link]');
      if (!container || !link) return;
      link.href = referrer.toString();
      container.hidden = false;
    }
  }

  if (!customElements.get('tsr-search-advanced')) {
    customElements.define('tsr-search-advanced', TsrSearchAdvanced);
  }

  } catch(e) { console.error(e); }
})();
})();
